<script setup>
import { Label, SwitchRoot, SwitchThumb } from 'reka-ui';
import { ErrorMessage, Field } from 'vee-validate';

const {
    fieldId,
    fieldName,
    label,
    disabled = false,
    required = false,
    inline = false,
    legend = null,
    withoutMargin = false,
} = defineProps({
    fieldId: {
        type: String,
        required: true,
    },
    fieldName: {
        type: String,
        required: true,
    },
    label: {
        type: String,
        required: false,
    },
    disabled: {
        type: Boolean,
        required: false,
    },
    required: {
        type: Boolean,
        required: false,
    },
    inline: {
        type: Boolean,
        required: false,
    },
    legend: {
        type: String,
        required: false,
    },
    withoutMargin: {
        type: Boolean,
        required: false,
    },
});

const model = defineModel();
</script>

<template>
    <div
        class="flex"
        :class="{
            'flex-col': !inline,
            'flex-row-reverse justify-end': inline,
            'mb-4': !withoutMargin,
        }"
    >
        <Label
            v-if="label"
            :for="fieldId"
            :class="{ 'mb-2': !inline, 'ml-2': inline }"
        >
            {{ label }}
            <sup v-if="required" class="text-red-500">*</sup>
        </Label>

        <Field v-model="model" :name="fieldName">
            <SwitchRoot
                v-model="model"
                :id="fieldId"
                :class="model ? 'bg-blue-600' : 'bg-gray-200'"
                class="relative inline-flex h-6 w-11 items-center rounded-full disabled:opacity-40"
                :disabled="disabled"
            >
                <SwitchThumb
                    :class="model ? 'translate-x-6' : 'translate-x-1'"
                    class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                />
            </SwitchRoot>
        </Field>

        <em v-if="legend" class="mt-1 text-xs text-gray-400">
            {{ legend }}
        </em>

        <ErrorMessage :name="fieldName" class="mt-1 text-sm text-red-500" />
    </div>
</template>
